function initClient() {
  var API_KEY = 'AIzaSyBKXFUTfvJc_499k0MXD3v3I7E97ADzHJo'; // TODO: Update placeholder with desired API key.

  var CLIENT_ID =
    '1011179671912-kk1nasg5ugq45jaei30jbli421hkbsd9.apps.googleusercontent.com'; // TODO: Update placeholder with desired client ID.

  // TODO: Authorize using one of the following scopes:
  //   'https://www.googleapis.com/auth/drive'
  //   'https://www.googleapis.com/auth/drive.file'
  //   'https://www.googleapis.com/auth/drive.readonly'
  //   'https://www.googleapis.com/auth/spreadsheets'
  //   'https://www.googleapis.com/auth/spreadsheets.readonly'
  var SCOPE = 'https://www.googleapis.com/auth/spreadsheets.readonly';

  gapi.client
    .init({
      apiKey: API_KEY,
      clientId: CLIENT_ID,
      scope: SCOPE,
      discoveryDocs: [
        'https://sheets.googleapis.com/$discovery/rest?version=v4',
      ],
    })
    .then(function () {
      gapi.auth2.getAuthInstance().isSignedIn.listen(updateSignInStatus);
      updateSignInStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
    });
}

function handleClientLoad() {
  gapi.load('client:auth2', initClient);
}

function updateSignInStatus() {
  read_data();
}
let dataQuery;

function read_data() {
  const ranges = ['Ranges1'];
  gapi.client.sheets.spreadsheets.values
    .batchGet({
      spreadsheetId: '11489a4Ace8DvesWoQBTjgRRVJAp4PRKsXaNR0BlKTmY',
      ranges: ranges,
    })
    .then((response) => {
      const result = response.result;
      let dataCountry = result.valueRanges[0].values;
      dataQuery = dataCountry;
      const content = document.querySelector('#content-address');
      for (let i = 0; i < dataCountry.length; i++) {
        const data = dataCountry;
        const e = document.createElement('li');
        e.setAttribute('data-province', data[i][3]);
        e.setAttribute('data-district', data[i][4]);
        e.setAttribute('data-address', data[i][5]);
        e.setAttribute(
          'data-code',
          data[i][5] + ' - ' + data[i][1] + ' - ' + data[i][0]
        );
        e.setAttribute('data-coords', data[i][6]);
        e.classList.add('ac');
        e.innerHTML = `<a href="javascript:;"><div class="icon_location"><svg class="icon icon-pin" xmlns="http://www.w3.org/2000/svg" version="1.0" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M2425 5114 c-480 -45 -876 -227 -1199 -550 -447 -447 -644 -1089 -516 -1675 50 -224 126 -426 240 -632 67 -121 1386 -2125 1428 -2170 104 -111 260 -111 364 0 25 27 1180 1769 1340 2023 252 398 380 816 364 1185 -13 294 -71 527 -195 773 -98 195 -205 344 -357 496 -285 284 -642 467 -1039 531 -95 15 -352 27 -430 19z m395 -240 c530 -77 1024 -447 1246 -932 112 -244 157 -446 157 -707 0 -123 -4 -172 -26 -275 -50 -239 -132 -445 -272 -678 -124 -208 -1351 -2057 -1365 -2057 -14 0 -1241 1849 -1365 2057 -131 219 -208 403 -260 623 -81 343 -42 687 119 1037 227 496 740 871 1281 937 178 22 311 21 485 -5z"></path><path d="M2390 4215 c-338 -61 -617 -286 -753 -605 -126 -297 -93 -653 84 -924 143 -217 344 -360 609 -433 92 -25 368 -25 460 0 265 73 466 216 609 433 140 213 192 487 141 734 -73 356 -325 642 -667 759 -145 49 -333 63 -483 36z m267 -216 c168 -23 312 -91 433 -205 251 -237 318 -594 170 -901 -98 -202 -278 -352 -497 -415 -111 -32 -295 -32 -406 0 -387 111 -631 491 -563 878 58 333 325 595 656 642 91 13 118 13 207 1z"></path></g></svg></div><div><span class="name-salon">${data[i][1]}</span><span class="excerpt">${data[i][5]}</span><span class="address-choose">Chọn salon</span></div></a>`;
        content.append(e);
      }
    });
}
